
<template>
  <div class="border">
      <ul >
        <li>
          <el-select  v-model="listLiData.productType" @change="changeProduct">
            <el-option
              v-for="items in getProductList()"
              :label="items.label"
              :key="items.value"
              :value="items.value"
            ></el-option>

          </el-select>
        </li>
        <li> <el-input-number v-model="listLiData.me" controls-position="right"></el-input-number></li>
        <li> <el-input-number v-model="listLiData.direct" controls-position="right"></el-input-number></li>
        <li> <el-input-number v-model="listLiData.indirect" controls-position="right"></el-input-number></li>
        <li> <el-input-number v-model="listLiData.quantity" controls-position="right"></el-input-number></li>
        <li>
          <div class="icon-area"
            @click="deleteList(listLiData.index,level)">
            <i class="el-icon-delete" style="font-size:24px;"></i>
          </div>
        </li>
      </ul>
  </div>
</template>

<script>
export default {
  props: ["listLiData",'level','activeType'],
  data() {
    return {
        productOptions: [
            {
                value: '2',
                label: "外汇"
            },
            {
                value: '1',
                label: "贵金属"
            },
            {
                value: '5',
                label: "指数"
            },
            {
                value: '4',
                label: "商品"
            },
            {
                value: '-1',
                label: "不限产品"
            },
            {
                value: '6',
                label: "货币"
            },
            {
                value: '7',
                label: "股票"
            }
        ]
    };
  },
  methods: {
      getProductList() {
        if(this.activeType==0){
            const index = this.productOptions.findIndex(d => d.value === '-1');
            if (index > -1) {
               return this.productOptions.splice(index, 1);
            }
            return this.productOptions;
        }
         return this.productOptions;
      },
    deleteList(index, level) {
      let idIndex = {
        level: level,
        index: index
      };
        this.$emit("deleteListData", idIndex);
    },
      changeProduct(val){
          let obj = {};
          obj = this.productOptions.find((item)=>{
              return item.value === val;
          });
          this.listLiData.name = obj.label;
      }
  },
  mounted() {}
};
</script>

<style lang="scss" scoped>
.test .el-form-item__content {
  display: flex;
}
.test .el-form-item__content .el-select--default {
  margin: 0 20px;
}
.task .el-checkbox-group {
  display: flex;
  flex-direction: column;
  height: 200px;
  overflow: scroll;
}
.border {
  margin-bottom: 15px;
 ul{
   display: flex;
   align-items: center;
   li{
     width: 180px;
     margin-right: 20px;
     .el-select{
       width: 180px;
     }
   }
 }
}
.icon-area{
  text-align: center;
}

.task .el-checkbox + .el-checkbox {
  margin-left: 0;
}
</style>
